// extracted by mini-css-extract-plugin
export var root = "TableOfContents-root--PgfK";
export var rootBackground = "TableOfContents-rootBackground-L7SYV";
export var rootBody = "TableOfContents-root_body-NBAKv";
export var rootBodyHeading = "TableOfContents-root_body_heading-iUx3d";
export var rootCol = "TableOfContents-root_col-LEPF7";
export var rootHeading = "TableOfContents-root_heading-ovSsx";
export var rootIcon = "TableOfContents-root_icon-qVDGc";
export var rootIconClose = "TableOfContents-root_icon-close-glgt7";
export var rootIconOpen = "TableOfContents-root_icon-open-DS2gL";
export var rootIconWrapper = "TableOfContents-root_iconWrapper-PiMIp";
export var rootIsOpen = "TableOfContents-root-isOpen-k1nlX";
export var rootList = "TableOfContents-root_list-v7BdH";
export var rootListItem = "TableOfContents-root_listItem-oQOds";
export var rootListLink = "TableOfContents-root_listLink-hb-gh";
export var rootListLinkActive = "TableOfContents-root_listLink-active-6SRva";
export var rootListWrapper = "TableOfContents-root_listWrapper-mCI6C";